import { FormEvent, useState } from "react";

import { Input } from "components/molecules";
import { Button, PasswordVisibilityToggler } from "components/atoms";

import { ButtonSize } from "interfaces/buttons";
import { User, Lock } from "lucide-react";

interface Props {
	login: string;
	password: string;
	code: string;
	submitTitle?: string;
	changeLogin: (value: string | number) => void;
	changePassword: (value: string | number) => void;
	changeCode: (value: string | number) => void;
	submit: (event: FormEvent) => void;
	isLoading: boolean;
	step: number;
}

const ForgotPasswordForm = (props: Props): JSX.Element => {
	const [isPasswordVisible, setPasswordVisibility] = useState(false);

	const {
		login,
		password,
		changeLogin,
		changePassword,
		submit,
		isLoading,
		submitTitle,
		changeCode,
		step,
		code,
	} = props;

	const togglePasswordVisibility = () => {
		setPasswordVisibility(!isPasswordVisible);
	};

	return (
		<form onSubmit={submit} autoComplete="on" className="w-full">
			{step === 1 ? (
				<div className="mb-6">
					<Input
						value={login}
						onChange={changeLogin}
						placeholder="E-mail"
						leftContainer={
							<div className="w-[65px] h-full flex justify-center items-center shrink-0">
								<User className="h-4 w-4 text-white" />
							</div>
						}
					/>
				</div>
			) : null}
			{step === 2 ? (
				<>
					<div className="mb-6">
						<Input
							value={code}
							onChange={changeCode}
							placeholder="Code"
							type="text"
						/>
					</div>
					<div className="mb-6">
						<Input
							value={password}
							onChange={changePassword}
							placeholder="Password"
							type={isPasswordVisible ? "text" : "password"}
							leftContainer={
								<div className="w-[65px] h-full flex justify-center items-center shrink-0">
									<Lock className="h-4 w-4 text-white" />
								</div>
							}
							rightContainer={
								<div className="w-[65px] h-full flex justify-center items-center shrink-0">
									<PasswordVisibilityToggler
										toggle={togglePasswordVisibility}
										isPasswordVisible={isPasswordVisible}
									/>
								</div>
							}
						/>
					</div>
				</>
			) : null}

			<Button
				type="submit"
				title={submitTitle || ""}
				isLoading={isLoading}
				size={ButtonSize.FULL_WIDTH}
			/>
		</form>
	);
};

export default ForgotPasswordForm;
